import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { ClienteAnaliseFinanceiraFormModule } from './form';

import { ClienteAnaliseFinanceiraComponent } from './cliente-analise-financeira.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteAnaliseFinanceiraFormModule
    ],
    declarations: [
        ClienteAnaliseFinanceiraComponent
    ],
    exports: [
        ClienteAnaliseFinanceiraComponent
    ]
})
export class ClienteAnaliseFinanceiraModule { }
